<!-- View Controls -->
<div class="calendar-header">
	<button mat-icon-button (click)="changeWeek(-1)">
		<mat-icon>chevron_left</mat-icon>
	</button>
	<h2>{{ getWeekRange(currentDate) }}</h2>
	<button mat-icon-button (click)="changeWeek(1)">
		<mat-icon>chevron_right</mat-icon>
	</button>
</div>
<div class="calendar-day" *ngFor="let day of days">
	<div class="day-header">{{ getDayFormat(day) }}</div>
	<div class="day-events" *ngIf="hasEvents(day); else noEvents">
		<div class="event-item" *ngFor="let event of getEventsForDay(day)" (click)="viewEvent(event)">
			<div class="content">
				<div class="event-time">
					<ng-container *ngIf="!startAndEndNotInSameDay(event)">
						{{ event.start_at | date:'HH:mm' }} - {{ event.end_at | date:'HH:mm' }}
					</ng-container>
					<ng-container *ngIf="startAndEndNotInSameDay(event)">
						{{ event.start_at | date:' d.MM.yy HH:mm' }} - {{ event.end_at | date:'d.MM.yy HH:mm' }}
					</ng-container>
				</div>
				<div class="event-title">{{ event.title }}</div>
				<div class="event-notes" *ngIf="event.notes">
					{{ event.notes }}
				</div>
			</div>
			<div class="link">
				<mat-icon>chevron_right</mat-icon>
			</div>
		</div>
	</div>
	<ng-template #noEvents>
		<div class="no-events">Geen agenda item</div>
	</ng-template>
</div>
